/* eslint-disable no-console */
/* eslint-disable no-tabs */
import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import axios from 'axios';
import qs from 'qs';

import actions from '../actions/login';
import rf from '../../requests/RequestFactory';

// saga effect
import {
  FETCH_QR_CODE,
  REGISTER,
  WAIT_FOR_AUTH,
  LOGIN_NORMAL,
  LOGIN_QR_1,
  VERIFY_EMAIL,
  LOGOUT, LOGIN_QR_2, LOGIN_QR_3,
} from '../actions/login/action_types';
import consts, { BASE_URL, PREFIX_FRONT_URL } from '../../consts';
import userActions from '../actions/user';
import favoritesAction from '../actions/favorites';
import settingDataAction from '../actions/setting_data';
import utils from '../../common/utils';

function* fetchQRcode() {
  try {
    const { data } = yield call(() => rf.getRequest('LoginRequest').fetchQRcode());
    yield put(actions.fetchQRcodeAction(data));
    yield put(actions.waitForAuthAction({
      step: 2,
      code: data.code,
    }));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.fetchQRcodeActionFailed(err));
  }
}

function* waitForAuth(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('LoginRequest').waitForConfirm(params), action.params.data);
    yield put(actions.waitForAuthActionSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.waitForAuthActionFailed(err));
  }
}

function* register(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('LoginRequest').register(params), action.params.data);
    yield put(actions.registerSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.registerFailed(err));
  }
}

function* loginNormal(action) {
  try {
    const resp = yield call((params) => rf.getRequest('LoginRequest').loginNormal(params), action.params.data);

    if (resp.error.code === 400) {
      utils.showNotification('Login', 'User or password is wrong', consts.TYPE_ERROR);
      return;
    }
    const { data } = resp;

    yield put(actions.loginNormalSucceed(data));
    //= ===================================
    // update axios header
    window.axios = axios.create({
      baseURL: BASE_URL,
      headers: {
        token: data.token,
      },
      paramsSerializer(params) {
        return qs.stringify(params);
      },
    });
    // fetch user balance actions
    yield put(userActions.fetchUserBalancesAction({
      uid: data.uid,
    }));
    //= ===================================

    // save session in storage
    window.localStorage.setItem('session', JSON.stringify(data));
    //= ===================================
    yield action.params.data.callback();
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.loginNormalFailed(err));
  }
}

function* verifyEmail(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('LoginRequest').verifyEmail(params), action.params.data);
    yield put(actions.verifyEmailSucceed(data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.verifyEmailFailed(err));
  }
}

function* logout(action) {
  try {
    const { data } = yield call((params) => rf.getRequest('LoginRequest').logout(params), action.params.data);
    const markets = yield call(() => rf.getRequest('LoginRequest').fetchMarkets());
    yield put(actions.logoutSucceed(data));
    window.localStorage.setItem('session', '');
    window.h.push(`${PREFIX_FRONT_URL}/home`);
    yield put(settingDataAction.fetchMarketActionSucceed(markets.data));
    yield put(favoritesAction.localFetchFavoritesAction());
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.logoutFailed(err));
  }
}

function* loginQRStep1(action) {
  console.log('=== loginQRStep1 ===');
  try {
    const resp = yield call(() => rf.getRequest('LoginRequest').loginQR1());

    if (resp.error.code === 400) {
      utils.showNotification('Login', 'Error Step 1', consts.TYPE_ERROR);
      yield put(actions.loginQR1Failed(new Error('Error Step 1')));
      return;
    }
    console.log(resp, 'resp');
    const { data } = resp;

    yield put(actions.loginQR1Succeed(data));
    console.log(data, 'data =======');
    yield put(actions.loginQR2({
      code: data.code, callback: action.params.data.callback,
    }));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.loginQR1Failed(err));
  }
}

function* loginQRStep2(action) {
  console.log('=== loginQRStep2 ===');
  try {
    const resp = yield call((params) => rf.getRequest('LoginRequest').loginQR2(params), action.params.data);

    if (resp.error.code === 400) {
      utils.showNotification('Login', 'Error Step 2', consts.TYPE_ERROR);
      yield put(actions.loginQR2Failed(new Error('Error Step 2')));
      return;
    }
    const { data } = resp;

    yield put(actions.loginQR2Succeed(data));
    console.log(data, 'data =======');
    console.log(resp, 'data =======');
    yield put(actions.loginQR3({
      code: data.code, callback: action.params.data.callback,
    }));
    // yield put(userActions.fetchUserBalancesAction({
    // 	uid: data.uid,
    // }));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.loginQR2Failed(err));
  }
}

function* loginQRStep3(action) {
  console.log('=== loginQRStep3 ===');
  try {
    let params = { ...action.params.data };
    const { pubkey } = localStorage.getItem('p') || {};
    if (`${pubkey}`.length !== consts.PUBKEY_LENGTH) {
      params = { ...params, referral: pubkey };
    }
    const resp = yield call((params) => rf.getRequest('LoginRequest').loginQR3(params), params);
    const markets = yield call(() => rf.getRequest('LoginRequest').fetchMarkets());
    if (resp.error.code === 400) {
      utils.showNotification('Login', 'Error Step 3', consts.TYPE_ERROR);
      yield put(actions.loginQR3Failed(new Error('Error Step 3')));
      return;
    }

    const { data } = resp;

    yield put(actions.loginQR3Succeed(data));
    console.log(data, 'data =======');
    //= ===================================
    // update axios header
    window.axios = axios.create({
      baseURL: BASE_URL,
      headers: {
        token: data.token,
      },
      paramsSerializer(params) {
        return qs.stringify(params);
      },
    });
    // fetch user balance actions
    yield put(userActions.fetchUserBalancesAction());
    //= ===================================

    // save session in storage
    yield window.localStorage.setItem('session', JSON.stringify(data));
    yield put(actions.loginQRSucceed(data));
    yield put(userActions.fetchUserInfoAction());
    yield put(settingDataAction.fetchMarketActionSucceed(markets.data));
    yield put(favoritesAction.fetchFavoritesAction());
    //= ===================================
    yield action.params.data.callback();
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.loginQR3Failed(err));
  }
}

function* watchAllUsers() {
  yield takeLatest(FETCH_QR_CODE, fetchQRcode);
  yield takeLatest(WAIT_FOR_AUTH, waitForAuth);
  yield takeLatest(REGISTER, register);
  yield takeLatest(LOGIN_NORMAL, loginNormal);
  yield takeLatest(LOGIN_QR_1, loginQRStep1);
  yield takeLatest(LOGIN_QR_2, loginQRStep2);
  yield takeLatest(LOGIN_QR_3, loginQRStep3);
  yield takeLatest(VERIFY_EMAIL, verifyEmail);
  yield takeLatest(LOGOUT, logout);
}

export default function* rootSaga() {
  yield all([fork(watchAllUsers)]);
}
